import usePagination from '@/hooks/usePagination';
import { useFileSearchQuery } from '@/modules/tasks/views/TasksDashboard/graphql/queries/generated/fileSearch';
import {
  FileCategoryEnum,
  FilePurposeEnum,
  FilesFilters,
  FileSubCategoryEnum,
} from '@/types/schema';

interface UseFileSearchProps {
  search?: string;
  pageSize?: number;
  filters?: Omit<FilesFilters, 'name'>;
  pause?: boolean;
}

// NOTE: keep in sync with @/components/FilterManager/EntityFilter/entity/files/index.ts

export const FILE_SEARCH_PROJECT_VARIABLES: FilesFilters = {
  systemGenerated: false,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.File],
  subCategories: [FileSubCategoryEnum.Project],
};

export const FILE_SEARCH_LIST_VARIABLES: FilesFilters = {
  systemGenerated: false,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.File],
  subCategories: [FileSubCategoryEnum.List],
};

export const FILE_SEARCH_STACK_VARIABLES: FilesFilters = {
  systemGenerated: false,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.Folder],
};

export const FILE_SEARCH_SYSTEM_GENERATED_VARIABLES: FilesFilters = {
  systemGenerated: true,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.File],
};

export const useFileSearch = (props: UseFileSearchProps) => {
  const { search, pageSize = 25, filters, pause } = props;
  const { data, isFetching, isFetchingMore, error, hasNextPage, fetchMore, totalCount } =
    usePagination(
      useFileSearchQuery,
      {
        filters: {
          name: search,
          ...filters,
        },
      },
      {
        edgeKey: 'files',
        pageSize,
        requestPolicy: 'cache-first',
        pause,
      },
    );
  return {
    files: data,
    isFetching,
    isFetchingMore,
    error,
    hasNextPage,
    fetchMore,
    totalCount,
  };
};
